/**
 * The WIPs a handover is built from: the Production Grid's list with the
 * stations' own scans laid over it (handoverLive.ts). One function so the
 * Handover screen and the automatic send read the SAME thing — a timer that
 * built its own view could send rows the screen would never have shown.
 */
import { productionGridService, type IProductionWip } from "../../lib/sp/ProductionGridService";
import { workcentersService } from "../../lib/sp/WorkcentersService";
import { listSlipsCached, listQcScansCached, listReceivingScansCached } from "../../lib/sp/sharedWipCache";
import { overlayLiveStations, type ILiveOverlayTally } from "./handoverLive";

export interface ILoadedHandover {
  wips: IProductionWip[];
  tally: ILiveOverlayTally;
  /** Scan lists that could not be read — those stations are NOT in `wips`. */
  missing: string[];
}

/** Forces the scan reads: a send must not be built on a list cached minutes ago. */
export async function loadHandoverWips(): Promise<ILoadedHandover> {
  const [w, [cut, slips, receiving, qc]] = await Promise.all([
    productionGridService.listWips(),
    Promise.allSettled([
      workcentersService.listCutReadyScans(),
      listSlipsCached(true),
      listReceivingScansCached(true),
      listQcScansCached(true),
    ]),
  ]);
  const missing = [
    cut.status === "rejected" ? "cutting scans" : "",
    slips.status === "rejected" ? "dispatch slips" : "",
    receiving.status === "rejected" ? "receiving scans" : "",
    qc.status === "rejected" ? "QC scans" : "",
  ].filter(Boolean);
  const merged = overlayLiveStations(w, {
    cut: cut.status === "fulfilled" ? cut.value : [],
    slips: slips.status === "fulfilled" ? slips.value : [],
    receiving: receiving.status === "fulfilled" ? receiving.value : [],
    qc: qc.status === "fulfilled" ? qc.value : [],
  });
  return { wips: merged.wips, tally: merged.tally, missing };
}
